import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { GetStateFn } from "../../utils/dispatchUtils";

export const blacklistViewOptionsSliceName = "blacklist";

export enum BlacklistViewColumn {
  TYPE = "type",
  CODE = "code",
  FAMILY = "family",
  DESCRIPTION = "description",
  EXPIRATION_DATE = "expirationDate",
}

export const blacklistViewColumnIds = [
  BlacklistViewColumn.TYPE,
  BlacklistViewColumn.CODE,
  BlacklistViewColumn.FAMILY,
  BlacklistViewColumn.DESCRIPTION,
  BlacklistViewColumn.EXPIRATION_DATE,
];

export type BlacklistViewOptionsState = {
  columns: string[];
};

const persistedBlacklistViewOptions = localStorage.getItem(blacklistViewOptionsSliceName);
const persistedState = persistedBlacklistViewOptions ? JSON.parse(persistedBlacklistViewOptions) as BlacklistViewOptionsState : null;
const fallback: BlacklistViewOptionsState = {
  columns: blacklistViewColumnIds,
};
const initialState: BlacklistViewOptionsState = persistedState ?? fallback;
// if columns does not exist, set default fallback value
if (initialState.columns === undefined || initialState.columns.length === 0) {
  initialState.columns = fallback.columns;
}

const blacklistViewOptionsSlice = createSlice({
  name: blacklistViewOptionsSliceName,
  initialState,
  reducers: {
    setBlacklistViewColumns(state: BlacklistViewOptionsState, action: { payload: string[] }) {
      state.columns = action.payload;
    },
  },
});

export type BlacklistViewOptionsRootState = { [blacklistViewOptionsSliceName]: BlacklistViewOptionsState };
export const selectBlacklistViewOptions = (state: BlacklistViewOptionsRootState) => state[blacklistViewOptionsSliceName];
export const setBlacklistViewColumns = (columns: string[]) => (dispatch: Dispatch, getState: GetStateFn) => {
  dispatch(blacklistViewOptionsSlice.actions.setBlacklistViewColumns(columns));
  persistState(getState);
};

function persistState(getState: GetStateFn) {
  localStorage.setItem(blacklistViewOptionsSliceName, JSON.stringify(selectBlacklistViewOptions(getState())));
}

export const blacklistViewOptionsReducer = blacklistViewOptionsSlice.reducer;
